import founderImage from '../assets/images/about/founder.png'
import integrityIcon from '../assets/icons/about/integrity.png'
import serviceIcon from '../assets/icons/about/service.png'
import innovationIcon from '../assets/icons/about/innovation.png'
import inclusivityIcon from '../assets/icons/about/inclusivity.png'
import team1 from '../assets/images/about/team-1.png'
import team2 from '../assets/images/about/team-2.png'
import team3 from '../assets/images/about/team-3.png'
import team4 from '../assets/images/about/team-4.png'
import team5 from '../assets/images/about/team-5.png'
import team6 from '../assets/images/about/team-6.png'
import team7 from '../assets/images/about/team-7.png'
import team8 from '../assets/images/about/team-8.png'

export const foundersMessageParagraphs = [
  'When we started Disha Foundation in 2011, we had a simple yet powerful vision: to empower the youth of India with the leadership skills, values, and vision needed to build a stronger, more prosperous nation. Today, as I reflect on our journey, I am filled with immense pride and gratitude for what we have achieved together.',
  'I invite you to join us in this mission. Whether you are a young person seeking to unlock your potential, a parent wanting the best for your child, or a volunteer passionate about nation building, there is a place for you at Disha Foundation.',
  'Our youth are not just the future of India; they are the present force that can drive meaningful change. Through our Public Leadership Camps, cultural initiatives, and various empowerment programs.',
]

export const aboutVision =
  'To create a generation of empowered, value-driven young leaders who are committed to building a progressive, inclusive, and prosperous India through leadership excellence, cultural awareness, social responsibility, and good governance.'

export const aboutMission =
  'To provide comprehensive leadership development programs, foster cultural pride, promote women empowerment, raise awareness about good governance, and engage youth in nation-building activities that create lasting positive impact on society.'

export const aboutTimeline = [
  {
    year: '2011',
    description:
      'Disha Foundation was established in 2011 in Surat, Gujarat, with a vision to create meaningful social impact through compassion, community support, and youth empowerment. What began as a small initiative driven by the desire to help people in need has now grown into a trusted organization dedicated to serving communities across Gujarat.',
  },
  {
    year: '2014',
    description:
      'Disha Foundation was founded in 2014 in Surat, Gujarat, with a mission to serve communities through compassion, social support, and meaningful change. Inspired by the growing need for community welfare and youth involvement, the foundation began as a small initiative focused on helping people with dignity, care, and humanity.',
  },
  {
    year: '2017',
    description:
      'Disha Foundation was established in 2017 in Surat, Gujarat, with a vision to create positive social impact through compassion, unity, and community service. Founded with the belief that even small acts of kindness can transform lives, the organization began its journey by supporting local communities and individuals in need.',
  },
  {
    year: '2020',
    description:
      'Disha Foundation was founded in 2020 in Surat, Gujarat, with a mission to support communities through compassion, care, and meaningful social initiatives. During challenging times, we recognized the growing need for community support, humanitarian service, and youth-driven social action.',
  },
  {
    year: '2023',
    description:
      'Disha Foundation was established in 2023 in Surat, Gujarat, with a vision to create meaningful change through compassion, community support, and social service. Founded with the belief that humanity grows stronger when people come together, the organization began its journey by helping individuals and families in need across local communities.',
  },
  {
    year: '2026',
    description:
      'Disha Foundation was founded in 2026 in Surat, Gujarat, with a vision to create a more compassionate and supportive society through community service and humanitarian initiatives. Built on the values of kindness, unity, and social responsibility, the foundation began its journey with the goal of making a meaningful difference in the lives of people who need support the most.',
  },
]

export const aboutValues = [
  {
    title: 'Integrity',
    description: 'Upholding honesty, transparency, and ethical conduct in all our actions',
    icon: integrityIcon,
    iconBgColor: 'rgba(183, 7, 7, 0.12)',
  },
  {
    title: 'Service',
    description: 'Dedicated commitment to serving society and contributing to nation building',
    icon: serviceIcon,
    iconBgColor: 'rgba(42, 111, 151, 0.12)',
  },
  {
    title: 'Innovation',
    description: 'Embracing creative solutions and progressive thinking for social change',
    icon: innovationIcon,
    iconBgColor: 'rgba(244, 162, 97, 0.12)',
  },
  {
    title: 'Inclusivity',
    description: 'Creating equal opportunities and fostering diversity in all our programs',
    icon: inclusivityIcon,
    iconBgColor: 'rgba(82, 183, 136, 0.12)',
  },
]

export const aboutTeamMembers = [
  { name: 'ADV. Darshan Vankalawala', image: team1, imageTransform: 'scaleY(-1) rotate(180deg)' },
  { name: 'Shri. Ambrish Parajiya', image: team2, objectPosition: 'bottom' },
  { name: 'Shri. Kalpesh Rawal', image: team3 },
  { name: 'Shri. Rohit Tiwari', image: team4, objectPosition: 'bottom' },
  { name: 'Shri. Vinod Gajera', image: team5 },
  { name: 'Shri. Harsh Sanghvi', image: team6, objectPosition: 'bottom' },
  { name: 'Shri. Gopal Goswami', image: team7 },
  { name: 'Shri. Parth Madhani', image: team8 },
]

export { founderImage }
